import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import * as validation from 'lib/validation'
import './SiteTools.scss'

const USER = 'User'
const USER_PASSWORD = 'UserPassword'

export default class ResetPasswordView extends React.Component {
  static propTypes = {
    isFetchingUsers: PropTypes.bool,
    users: PROPTYPES.users,
    resetPassword: PropTypes.func,
    passwordReset: PropTypes.bool,
  }

  static defaultProps = {
    isFetchingUsers: false,
    users: [],
    resetPassword: _.noop,
    passwordReset: false,
  }

  constructor (props) {
    super(props)
    this.state = {
      [`selected${USER}`]: null,
      [`selected${USER_PASSWORD}`]: null,
      [`input${USER}`]: '',
      [`input${USER_PASSWORD}`]: '',
    }
  }

  handleSelect = (resourceType, selected) => {
    if (selected == null) {
      selected = ''
    }
    this.setState({ [`selected${resourceType}`]: selected })
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const {
      selectedUser,
      inputUserPassword,
    } = this.state

    if (resourceType === USER) {
      if (selectedUser && inputUserPassword) {
        return true
      }
    }
    return false
  }

  handleResetPassword = () => {
    const { selectedUser, inputUserPassword } = this.state
    const { resetPassword } = this.props
    const passwordResult = validation.validatePassword(inputUserPassword)
    this.setState({
      [`alert${USER_PASSWORD}`]: {
        show: !passwordResult.valid,
        errors: passwordResult.errors
      }
    })
    if (passwordResult.valid) {
      resetPassword(selectedUser.email, inputUserPassword)
    }
  }

  renderAlert = (resourceType) => {
    const alert = this.state[`alert${resourceType}`]
    if (alert && alert.show) {
      return _.map(alert.errors, (error, index) => (
        <div className='alert alert-danger' key={index}>{error}</div>
      ))
    }
  }

  render () {
    const {
      isFetchingUsers,
      users,
      passwordReset
    } = this.props
    const {
      selectedUser,
      inputUserPassword,
    } = this.state
    return (
      <div className='step-form'>
        <div>
          <Step
            title='User'
            isCollapsed={!!passwordReset}
          >
            {
              passwordReset
              ? <div>
                Password Reset
              </div>
              : <div>
                <div>Email</div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingUsers}
                  options={users}
                  value={selectedUser}
                  onChange={(selected) => this.handleSelect(USER, selected)}
                  onInputChange={(input) => this.handleInput(USER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'email'}
                  valueKey={'user_id'}
                />
                <div>Password</div>
                { this.renderAlert(USER_PASSWORD) }
                <input
                  type='password'
                  className='input'
                  value={inputUserPassword}
                  onChange={(event) => this.handleInput(USER_PASSWORD, event.target.value)}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={this.handleResetPassword}
                    disabled={!this.checkPrereqs(USER)}
                  >
                    Reset Password
                  </button>
                </div>
              </div>
            }
          </Step>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PasswordResetView.jsx